import { combineReducers } from 'redux';
import {
  languageReducer,
  authReducer,
  quotationReducer,
  userReducer,
  formReducer,
  providerReducer,
  OfferReducer,
  ClientReducer,
  LeadReducer,
  ColorReducer,
  BrandReducer,
  CommentReducer,
  BannerReducer,
  FAQReducer,
  ServiceReducer,
  BlogReducer,
  SalesReducer,
  ReportReducer,
} from './index';
import { ModelReducer } from './model';
import { VersionReducer } from './version';

export const rootReducer = combineReducers({
  lang: languageReducer,
  auth: authReducer,
  user: userReducer,
  forms: formReducer,
  provider: providerReducer,
  quotation: quotationReducer,
  offer: OfferReducer,
  client: ClientReducer,
  lead: LeadReducer,
  color: ColorReducer,
  brand: BrandReducer,
  model: ModelReducer,
  version: VersionReducer,
  comment: CommentReducer,
  banner: BannerReducer,
  faq: FAQReducer,
  service: ServiceReducer,
  blog: BlogReducer,
  sales: SalesReducer,
  report: ReportReducer,
});
